export default __webpack_public_path__ + "static/media/image3.23390752.png";